import logo from "./logo.svg";
import "./App.css";
import Home from "./Home";
import { useEffect } from "react";

function App() {
  //experiment for jsonp
  // useEffect(() => {
  //   const fetchData = () => {
  //     // Generate a unique callback function name
  //     const callbackName = "jsonpCallback" + Date.now();

  //     // Create a script element
  //     const script = document.createElement("script");

  //     // Set the script source with the unique callback function name
  //     script.src = `https://www.ragic.com/demo/sales/1?v=3&api&callback=${callbackName}`;

  //     // Append the script element to the document body
  //     document.body.appendChild(script);

  //     // Define the global callback function
  //     window[callbackName] = (data) => {
  //       console.log("data", data);

  //       // Clean up by removing the script tag and global callback
  //       document.body.removeChild(script);
  //       delete window[callbackName];
  //     };
  //   };

  //   fetchData();
  // }, []);
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
